import React from "react";
import { connect } from "react-redux";
import { Navbar, NavLeft, NavRight, NavTitle, Link, Badge } from "framework7-react";
import { PendingSyncTrigger } from "modules/offline/PendingSyncSheet";

const mapStateToProps = (state) => ({
  offline_status: state.offline_status,
});

const AppNavbar = ({ title, backLink, offline_status }) => {
  const { online, pendingCount = 0, conflictCount = 0, syncing } = offline_status || {};

  let statusLabel = null;
  let statusColor = "gray";
  if (!online) {
    statusLabel = pendingCount > 0 ? "Saved on phone" : "Offline";
    statusColor = "orange";
  } else if (syncing) {
    statusLabel = "Syncing";
    statusColor = "blue";
  } else if (conflictCount > 0) {
    statusLabel = "Conflict";
    statusColor = "red";
  }

  return (
    <Navbar>
      <NavLeft>
        {backLink && <Link back iconF7="arrow_left" />}
        <Link panelOpen="left" iconF7="bars" />
      </NavLeft>
      <NavTitle>{title}</NavTitle>
      {(statusLabel || pendingCount > 0) && (
        <NavRight>
          <PendingSyncTrigger>
            {statusLabel && <Badge color={statusColor}>{statusLabel}</Badge>}
            {pendingCount > 0 && <Badge color="orange">{pendingCount} to Sync</Badge>}
          </PendingSyncTrigger>
        </NavRight>
      )}
    </Navbar>
  );
};

export default connect(mapStateToProps)(AppNavbar);
